'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useCallback, useMemo } from 'react';
import { useCommonData } from '@udemy-v2/common-data';
import { useFeatures } from '@udemy-v2/react-experimentation';
import { udExpiringLocalStorage } from '@udemy-v2/utils';
import { NVD_PASSWORDLESS_LOGIN_EXPERIMENT } from '../constants';

// The modal only shows once per user across page loads
const browserStore = udExpiringLocalStorage('frontends-course-landing-page', 'activation-offer-modal');
const STORAGE_KEY = 'udemy/activation-offer-modal/shown';

/**
 * Hook to manage activation offer modal state and visibility logic
 */
export function useActivationOfferModal() {
  const $ = _c(11);
  const commonData = useCommonData();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [NVD_PASSWORDLESS_LOGIN_EXPERIMENT];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    isLoading,
    featureVariantAssignments
  } = useFeatures(t0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  commonData?.user?.id;
  const isLoggedOut = !commonData?.user?.id;
  let t1;
  bb0: {
    if (isLoading) {
      t1 = false;
      break bb0;
    }
    let t2;
    if ($[1] !== featureVariantAssignments) {
      t2 = featureVariantAssignments.get(NVD_PASSWORDLESS_LOGIN_EXPERIMENT);
      $[1] = featureVariantAssignments;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    const variant = t2;
    const config = variant?.configuration as {
      enable_nvd?: boolean;
    } | undefined;
    t1 = !!(config?.enable_nvd === true);
  }
  const isExperimentEnabled = t1;
  let t2;
  bb1: {
    if (typeof window === "undefined") {
      t2 = false;
      break bb1;
    }
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = browserStore.get(STORAGE_KEY);
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    t2 = !!t3;
  }
  const hasBeenShown = t2;
  const canShowModal = isLoggedOut && isExperimentEnabled && !hasBeenShown;
  let t3;
  if ($[4] !== canShowModal) {
    t3 = () => {
      if (canShowModal) {
        setIsModalOpen(true);
        if (typeof window !== "undefined") {
          browserStore.set(STORAGE_KEY, true);
        }
      }
    };
    $[4] = canShowModal;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const showModal = t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setIsModalOpen(false);
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const hideModal = t4;
  let t5;
  if ($[7] !== canShowModal || $[8] !== isModalOpen || $[9] !== showModal) {
    t5 = {
      isOpen: isModalOpen,
      showModal,
      hideModal,
      canShowModal
    };
    $[7] = canShowModal;
    $[8] = isModalOpen;
    $[9] = showModal;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}